<div
  class="flex bg-[#252A30] justify-between items-center h-full w-full text-white"
>

  <div
    class="flex justify-between items-center py-[0.5%] pb-[0.5%] pl-6 flex-wrap company-logo h-full"
  [ngClass]="{
  'hidden lg:flex': !isLargeScaleUser()
}"
  >
    <img
      [src]="'../../../../assets/svg/customer-logo.svg'"
      class="mr-3 h-full"
      alt=""
    />
  </div>

@if (!isLargeScaleUser()) {
  <div class="lg:hidden ml-6" (appClickableDirective)="onToggleSidebar()">
    <img src="../../../../assets/images/hamburger-icon.svg" class="h-5" alt="Menu"/>
  </div>
}
  <div class="flexCenter space-x-2 h-full">
    <div class="flexCenter h-full">
      @if (this.user.userCategory == userCategory.PREMIUM) {
        <div class="pt-[2.53%]">
          <img
            class="imgs"
            src="../../../../assets/images/Group 48095330.svg"
            alt="Premium User"
          />
        </div>
      }

      <img
        [src]="
          user.user_image
            ? user.user_image
            : '../../../../assets/svg/default-user.svg'
        "
        alt="Avator"
        routerLink="/user-profile"
        class="h-7 w-7 rounded-full"
      />
    </div>

    <div
      class="relative flex cursor-default gap-x-1"
      (appClickableDirective)="toggleDropdown()"
      onClickOutside
      (onClickOutside)="clickOutside()"
    >
      <div class="flex flex-col leading-normal">
        <div class="flexCenter">
          @if (user) {
            <span class="text-base">{{
              user.firstName||user.name
            }}</span>
          }
        </div>
      </div>
      <div>
        <span
          class="mr-6 ml-[0.6rem] text-base"
          [ngClass]="{
            'rounded-xl': !dropdownOpen,
            'rounded-t-xl': dropdownOpen
          }"
        ><app-angle-down-icon />
        </span>
      </div>
      @if(dropdownOpen){
      <div
        class="absolute right-5 sm:top-[2.8rem] md:top-[2.7rem] lg:top-[2.2rem] z-30 w-[140px] bg-dimGrey shadow-lg focus:outline-none rounded-b-xl"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="menu-button"
        tabindex="-1"
      >
        <div class="flex flex-col px-3 mb-2 mt-1 w-full">
          <div class="flex items-center w-full">
            <div class="py-2 w-full">
              <span
                class="text-gray-700 p-1.5 items-center w-full flex dark:text-white text-sm hover:dark:bg-gray-500 hover:bg-slate-50 hover:bg-opacity-80 rounded-lg cursor-default"
                role="menuitem"
                tabindex="-1"
                routerLink="/user-profile"
              >
                <div>
                  <img
                    src="../../../../assets/images/first-img.svg"
                    class="h-5"
                    alt="first"
                  />
                </div>
                <div><span class="ml-2">User Info </span></div>
              </span>
            </div>
          </div>
          <div class="items-center flex w-full justify-center">
            <div class="py-2 w-full">
              <span
                class="text-gray-700 p-1.5 w-full dark:text-white flex text-sm hover:dark:bg-gray-500 hover:bg-slate-50 rounded-lg cursor-default"
                role="menuitem"
                tabindex="-1"
                (appClickableDirective)="logout()"
                ><div>
                  <img
                    src="../../../../assets/images/sec-img.svg"
                    class="h-5"
                    alt="sec"
                  />
                </div>
                <div><span class="ml-2">Logout</span></div></span
              >
            </div>
          </div>
        </div>
      </div>}
    </div>
  </div>
</div>
